import { useLogto } from '@logto/react';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../contexts/ThemeContext';

export function Logout() {
  const { signIn, isLoading } = useLogto();
  const { theme } = useTheme();
  const { t } = useTranslation();
  const triggeredRef = useRef(false);

  useEffect(() => {
    if (isLoading) return;
    if (triggeredRef.current) return;
    triggeredRef.current = true;
    void signIn(`${window.location.origin}/callback`);
  }, [signIn, isLoading]);

  return (
    <div className={`auth-screen theme-${theme}`}>
      <div className="loading-screen">{t('signingOut')}</div>
    </div>
  );
}
